import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { ENTITIES } from 'src/models/QuerybuilderModel';
import { deleteContactAction } from 'src/redux/actions/contactActions';
import { closeDialog } from 'src/redux/actions/dialogActions';

const DeleteContactDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.deleteContact]) {
        return state.dialog[DIALOGS.deleteContact];
      }
      return { opened: false, payload: null };
    });
  const selected = useSelector((state: Store) => state.selected[ENTITIES.contacts]);
  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteContact }));
  };

  const handleOk = () => {
    const ids = payload ? payload.ids : selected;
    dispatch(deleteContactAction(ids));
    dispatch(closeDialog({ dialog: DIALOGS.deleteContact }));
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="deleting-contact"
      open={opened}>
      <DialogTitle id="deleting-contact">{t(lang, 'menus.deleting_contact')}</DialogTitle>
      <DialogContent dividers>
        {t(lang, 'menus.deleting_contact_confirmation')}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          {t(lang, 'misc.no')}
        </Button>
        <Button onClick={handleOk} color="primary">
          {t(lang, 'misc.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteContactDialog;
